export interface SatisfactionItem {
    value: number;
    icon: string;
    title: string;
    color: string;
}

export const SatisfactionConstants: SatisfactionItem[] = [
    {
        value: 5,
        icon: "sentiment_very_satisfied",
        title: "خیلی خوب",
        color: "#188f40",
    },
    {
        value: 4,
        icon: "sentiment_satisfied_alt",
        title: "نسبتا خوب",
        color: "#188f69",
    },
    {
        value: 3,
        icon: "sentiment_neutral",
        title: "معمولی",
        color: "#636363",
    },
    {
        value: 2,
        icon: "sentiment_dissatisfied",
        title: "نسبتا بد",
        color: "#c45e0a",
    },
    {
        value: 1,
        icon: "sentiment_very_dissatisfied",
        title: "خیلی بد",
        color: "#e00000",
    },
];
